module.exports = __webpack_public_path__ + "img/icon-powered-by.aab4be68.svg";